/**
 * Settings ▸ Repository roles — which repo plays which documentation role.
 *
 * One page for the five tri-state capabilities (guided-repo-setup Phase B):
 * the capability rows own every repo choice — fitness included — and the CI
 * section below keeps the picker-less operational wiring details.
 */

import DocReposTab from './DocReposTab';
import CiIntegrationTab from './CiIntegrationTab';

export default function RepositoryRolesPage() {
  return (
    <div className="space-y-12">
      <DocReposTab />
      <CiIntegrationTab />
    </div>
  );
}
